import { setupClient } from "Infrastructure/Api/Api";
import { type FC, type PropsWithChildren, useEffect } from "react";

//TODO[ADRIAN]: This does nothing at all...
export const AuthMiddleware: FC<PropsWithChildren> = ({ children }) => {
	useEffect(() => {
		setupClient({
			apiUrl: import.meta.env.VITE_API_DOMAIN,
			jwtKey: () => undefined,
			requestMiddlewares: [
				{
					name: "Add cookie token",
					fn: (request) => {
						return request;
					},
				},
			],
			responseMiddlewares: [
				{
					name: "Handle 4xx errors",
					fn: (response) => {
						if (response.status === 0 || response.status === 401) {
						}

						return response;
					},
				},
			],
		});
	}, []);

	return <>{children}</>;
};
